import React from 'react';
import { CTAButton } from './CTAButton';
import { CheckCircle2Icon, ShieldCheckIcon, LockIcon } from 'lucide-react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function OfferSection() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section id="oferta" className="bg-navy-dark py-16 md:py-24 relative overflow-hidden" data-id="element-235">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-navy-light via-navy-dark to-navy-dark pointer-events-none" data-id="element-236"></div>

      <div ref={elementRef} className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-237">
        <div className="text-center mb-10" data-id="element-238">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-white" data-id="element-239">
            Lo Que Obtienes Hoy
          </h2>
        </div>

        <div className="bg-gradient-to-b from-navy-light to-navy-dark p-8 md:p-12 rounded-3xl border-2 border-gold-primary shadow-[0_0_50px_rgba(212,175,55,0.15)] max-w-2xl mx-auto" data-id="element-240">
          <ul className="space-y-5 mb-10 text-left" data-id="element-241">
            <li className="flex items-start gap-4" data-id="element-242">
              <CheckCircle2Icon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-243" />
              <span className="text-lg md:text-xl text-gray-200" data-id="element-244">
                <span className="text-white font-semibold" data-id="element-245">
                  eBook PDF Completo
                </span>{' '}
                — "El Dinero Que El IRS Te Debe y Nadie Te Dijo Cómo Reclamar"
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-246">
              <CheckCircle2Icon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-247" />
              <span className="text-lg md:text-xl text-gray-200" data-id="element-248">
                <span className="text-white font-semibold" data-id="element-249">Los 3 Hacks</span>{' '}
                explicados paso a paso en lenguaje simple, sin jerga legal
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-250">
              <CheckCircle2Icon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-251" />
              <span className="text-lg md:text-xl text-gray-200" data-id="element-252">
                <span className="text-white font-semibold" data-id="element-253">
                  Guía de Enmiendas:
                </span>{' '}
                qué años revisar y cómo identificar dinero no reclamado
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-254">
              <CheckCircle2Icon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-255" />
              <span className="text-lg md:text-xl text-gray-200" data-id="element-256">
                <span className="text-white font-semibold" data-id="element-257">
                  La regla del dependiente que trabaja:
                </span>{' '}
                los factores exactos que debes cumplir
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-258">
              <CheckCircle2Icon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-259" />
              <span className="text-lg md:text-xl text-gray-200" data-id="element-260">
                <span className="text-white font-semibold" data-id="element-261">
                  La estrategia de deuda inteligente:
                </span>{' '}
                cómo calcular si te conviene y cómo ejecutarla correctamente
              </span>
            </li>
            <li className="flex items-start gap-4" data-id="element-262">
              <CheckCircle2Icon className="w-6 h-6 text-green-400 flex-shrink-0 mt-1" data-id="element-263" />
              <span className="text-lg md:text-xl text-gray-200" data-id="element-264">
                <span className="text-white font-semibold" data-id="element-265">
                  Acceso inmediato
                </span>{' '}
                — descarga al instante desde cualquier dispositivo
              </span>
            </li>
          </ul>

          <p className="text-lg text-gold-light italic text-center mb-10" data-id="element-266">
            Todo esto por menos de lo que pagas por un café en Starbucks.
          </p>

          <div className="text-center" data-id="element-267">
            <CTAButton className="w-full md:w-auto text-xl py-6 px-10" data-id="element-268" />

            <div className="mt-8 flex flex-col md:flex-row items-center justify-center gap-6 text-sm text-gray-400" data-id="element-269">
              <div className="flex items-center gap-2" data-id="element-270">
                <LockIcon className="w-5 h-5 text-green-400" data-id="element-271" />
                <span data-id="element-272">Pago 100% Seguro</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-273">
                <ShieldCheckIcon className="w-5 h-5 text-green-400" data-id="element-274" />
                <span data-id="element-275">Acceso Inmediato 24/7</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}